import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { components } from 'react-select';
import { styled } from '@mui/material/styles';
import GroupProvider from '../context/GroupProvider.js';

const Separator = styled('hr') `
  border: none;
  border-top: 1px solid ${({ theme }) => theme.palette.N30.main};
  width: 100%;
  margin: 0;
`;
const TopSeparator = styled(Separator) ``;
const BottomSeparator = styled(Separator) `
  margin: ${({ theme }) => theme.spacing(-1, 0, 1, 0)};
`;
const Group = (props) => (jsxs(Fragment, { children: [jsx(TopSeparator, {}), jsx(GroupProvider, { children: jsx(components.Group, Object.assign({}, props)) }), jsx(BottomSeparator, {})] }));

export { Group as default };
//# sourceMappingURL=Group.js.map
